import { render, staticRenderFns } from "./ArrowToTop.vue?vue&type=template&id=53187b36&scoped=true"
import script from "./ArrowToTop.vue?vue&type=script&lang=js"
export * from "./ArrowToTop.vue?vue&type=script&lang=js"
import style0 from "./ArrowToTop.vue?vue&type=style&index=0&id=53187b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53187b36",
  null
  
)

export default component.exports